import React, { Component } from 'react';

import { Helmet } from 'react-helmet';

interface ITitleProps {
    title: string;
    hasTiger?: boolean;
}

class Title extends Component<ITitleProps> {
    render() {
        return (
            <Helmet>
                <title>
                    {this.props.title}
                    {this.props.hasTiger ? ' - TradeUP' : ''}
                </title>
            </Helmet>
        );
    }
}

export default Title;
